// extracted by mini-css-extract-plugin
export default {"Container":"Summary_Container__2KEEy","info":"Summary_info__Mr+U2"};